/**
 * Conflict Zone Manager Module
 * Handles GeoJSON control areas and territorial boundaries
 */

import { getGeoJsonData } from '../config/firebase';
import { selectedLanguage } from '../utils/translation';
import { getControlAreaLayers } from './mapConfig';

/**
 * Load and display GeoJSON control areas for a country
 */
export function loadControlAreas(databaseName) {
    console.log('Loading GeoJSON control areas for:', databaseName);
    const controlAreaLayers = getControlAreaLayers();
    
    if (!controlAreaLayers) {
        console.error('Control area layers not initialized!');
        return;
    }
    
    console.log('Control area layers available, fetching GeoJSON data...');
    
    // TODO: Consider caching loaded GeoJSON data to avoid redundant fetches
    // DONE: handle all fetched data from zones/----
    getGeoJsonData(databaseName).then(jsonData => {
        console.log('GeoJSON data received:', jsonData);
        
        if (!jsonData || !jsonData.features || jsonData.features.length === 0) {
            console.warn('No GeoJSON features found for:', databaseName);
            return;
        }
        
        console.log(`Processing ${jsonData.features.length} GeoJSON features...`);
        
        const geojsonLayer = L.geoJSON(jsonData, {
            style: function (feature) {
                return {
                    color: feature.properties['stroke'] || '#3388ff',
                    weight: feature.properties['stroke-width'] || 2,
                    opacity: feature.properties['stroke-opacity'] || 1,
                    fillColor: feature.properties.fill || '#3388ff',
                    fillOpacity: feature.properties['fill-opacity'] || 0.2,
                    dashArray: '1',
                };
            },
            onEachFeature: function (feature, layer) {
                // Add popup with localized description
                const isRTL = selectedLanguage === 'ar';
                const controlMapTitle = {
                    "en": feature.properties.control_en,
                    "ar": feature.properties.control_ar,
                    "tr": feature.properties.control_tr,
                };

                const descriptionMap = {
                    "en": feature.properties.description_en,
                    "ar": feature.properties.description_ar,
                    "tr": feature.properties.description_tr,
                };
                const description = descriptionMap[selectedLanguage] || feature.properties.description_en;
                const control = controlMapTitle[selectedLanguage] || feature.properties.control_en;
                
                const popupContent = `
                    <div class="custom-popup ${isRTL ? 'rtl' : ''}">
                        <h6>${control}</h6>
                        <p><strong>${description}</strong></p>

                    </div>
                    `;
                if (description) {
                    layer.bindPopup(popupContent);
                }
            },
        }).addTo(controlAreaLayers);
        
        console.log('GeoJSON control areas added to map successfully');
    }).catch(error => {
        console.error("Error loading GeoJSON control areas:", error);
    });
}

/**
 * Clear all control areas from the map
 */
export function clearControlAreas() {
    const controlAreaLayers = getControlAreaLayers();
    
    if (controlAreaLayers) {
        controlAreaLayers.clearLayers();
        console.log('Control areas cleared');
    }
}
